<template>
  <div class="yk-custom-select-container">
    <el-select ref="dateTime" v-model="selectedValue" multiple :placeholder="placeholder" v-if="type === '0'" size="small">
      <el-option
        v-for="item in shopList"
        :key="item.merchantId"
        :label="item.merchantName"
        :value="item.merchantId">
      </el-option>
      <el-input class="mask" slot="prefix" style="width: 200px" :placeholder="placeholder"></el-input>
    </el-select>
    <!-- 收银点 -->
    <el-select ref="dateTime" v-model="selectedValue" multiple :placeholder="placeholder" v-if="type === '1'" size="small">
      <el-option
        v-for="item in shopList"
        :key="item.cashierAreaNo"
        :label="item.cashierAreaName"
        :value="item.cashierAreaNo">
      </el-option>
      <el-input class="mask" slot="prefix" style="width: 200px" :placeholder="placeholder"></el-input>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    list: {
      type: Array,
      default: () => [],
    },
    // 新增收银点,以type区分,0表示门店,1表示收银点
    type: {
      type: String,
      default: () => "0",
    },
  },
  data() {
    return {
      placeholder: this.type === "0" ? '全部门店' : '请选择收银点',
      shopList: this.list,
      selectedValue: this.value,
      shopType: 1,
    };
  },
  watch: {
    value(newV) {
      if (newV[0] === '@') {
        this.placeholder = this.type === "0" ? '全部门店' : '请选择收银点';
      } else {
        this.placeholder = this.type === "0" ? '请选择门店' : '请选择收银点';
      }
      this.selectedValue = newV;
    },
    list(newV) {
      this.shopList = newV;
    },
    selectedValue(newV) {
      // 如果选择了全部门店，其他门店取消选中；如果选择了其他门店，全部门店取消选中
      if (newV.length > 1 && newV[newV.length - 1] === '@') {
        newV = ['@'];
      } else if (newV.length > 1 && newV.indexOf('@') !== -1) {
        newV = newV.filter(v => v !== '@');
      }
      this.$emit('changeShop', newV);
      this.$emit('input', newV);
    },
  },
  methods: {
  },
  mounted() {
    this.$refs.dateTime.$el.children[0].addEventListener('click', (e) => {
      if (e.target.className.indexOf('el-tag__close') === -1) {
        this.$refs.dateTime.visible = false;
        e.stopPropagation();
      }
    });
  },
};
</script>
<style lang="scss">
.yk-custom-select-container {
  position: relative;
  height: 32px;
  .el-select {
    width: 200px;
    z-index: 2;
    position: static;
    .el-select__tags {
      position: absolute;
      left: 220px;
      // margin-top: -5px;
      max-width: 1000px!important;
      width: 1000px!important;
      > span {
        display: flex;
        flex-wrap: wrap;
        .el-tag {
          height: 32px;
          line-height: 32px;
          display: flex;
          max-width: 100%;
          .el-tag__close {
            margin-right: 5px;
            cursor: pointer;
            font-size: 15px;
          }
        }
      }
    }
    > .el-input {
      .el-input__prefix {
        left: 0;
        .mask {
          opacity: 1!important;
        }
      }
      > input {
        opacity: 0;
      }
      .el-select__caret {
        height: 32px!important;
      }
    }
  }
}
</style>
